import { ValueParserParams } from 'ag-grid-community';

const gridNumberParser = (params: ValueParserParams) => {
    return Number(params.newValue);
};

export default {
    number: (params: ValueParserParams) => gridNumberParser(params),
};
